export default "__VITE_ASSET__RcQS5HcA__"